const formatDate = (date: Date) =>
  date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
const formatDateTime = (date: Date) =>
  date.toLocaleTimeString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });

const isNewerDate = (referenceDate: Date | undefined, testDate: Date | undefined): boolean =>
  testDate !== undefined && (referenceDate === undefined || testDate.getTime() > referenceDate.getTime());

export { formatDate, formatDateTime, isNewerDate };
